// extracted by mini-css-extract-plugin
export default {"container":"oz-z"};